import { __assign } from 'tslib';
import { createError } from './error';

export function assertNever(obj: never, errorMessage: string): never {
    throw createError('Never assertion failed: ' + errorMessage);
}

export function hasOwn(object: any, propertyName: string): boolean {
    // Don't do {}.hasOwnProperty because the {} may have overwritten
    // hasOwnProperty with it's own implementation that doesn't behave
    // as we expect. Instead we always reference the true hasOwnProperty
    // which exists on the Object.prototype (unless someone overrides that
    // which they just shouldn't ever do...)
    return Object.prototype.hasOwnProperty.call(object, propertyName);
}

export const assign: ObjectAssign = (Object as any).assign || __assign;

export interface ObjectAssign {
    /**
     * Copy the values of all of the enumerable own properties from one or more source objects to a
     * target object. Returns the target object.
     * @param target The target object to copy to.
     * @param source The source object from which to copy properties.
     */
    <T, U>(target: T, source: U): T & U;

    /**
     * Copy the values of all of the enumerable own properties from one or more source objects to a
     * target object. Returns the target object.
     * @param target The target object to copy to.
     * @param source1 The first source object from which to copy properties.
     * @param source2 The second source object from which to copy properties.
     */
    <T, U, V>(target: T, source1: U, source2: V): T & U & V;

    /**
     * Copy the values of all of the enumerable own properties from one or more source objects to a
     * target object. Returns the target object.
     * @param target The target object to copy to.
     * @param source1 The first source object from which to copy properties.
     * @param source2 The second source object from which to copy properties.
     * @param source3 The third source object from which to copy properties.
     */
    <T, U, V, W>(target: T, source1: U, source2: V, source3: W): T & U & V & W;

    /**
     * Copy the values of all of the enumerable own properties from one or more source objects to a
     * target object. Returns the target object.
     * @param target The target object to copy to.
     * @param sources One or more source objects from which to copy properties
     */
    (target: object, ...sources: any[]): any;
}
